export default {
  agency_key: '',
  mode: '',
  chat_url: '',
  beian: '',
  beian_gn: '',

  address: '武汉市东湖新技术开发区光谷总部国际',
  uc_host: 'http://user.xiongzhangyun.com',
  site_host: 'http://www.xiongzhangyun.com',
  special_url: '/',
  site_title: '熊掌云-软文精准营销平台',
  welcome_title: '熊掌云 — 软文精准营销平台！',
  site_short_title: '熊掌云',
  site_subtitle: '软文精准营销平台',
  company_name: '武汉优享信网络有限公司',
  copyright: '© 2021 武汉优享信网络有限公司',
  logo: 'http://www.xiongzhangyun.com/img/logo.png',
  favicon: 'http://www.xiongzhangyun.com/favicon.ico',
  payment: '',
  qq: '619540571',
  tel: '027-87806966',
  company_account_id: '3202 0090 0920 0566 171',
  company_bank: '中国工商银行武汉市东湖开发区支行',
  company_bank_name: '武汉优享信网络有限公司',
  alipay_account_id: 'xin@whuxx.com',
  alipay_name: '武汉优享信网络有限公司',
  alipay_pic: '',
  section_id: 671864,
  belonger_id: 671864,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 